import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/SocialCallback.css';

const KakaoCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { kakaoLogin } = useAuth();
  
  useEffect(() => {
    // 카카오 로그인 콜백 처리
    const processKakaoLogin = async () => {
      // 카카오 SDK가 로드되었는지 확인
      if (!window.Kakao) {
        console.error('카카오 SDK를 로드할 수 없습니다.');
        navigate('/login?error=kakao_sdk_load_failed');
        return;
      }
      
      // URL에서 인증 코드 추출
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      
      if (!code) {
        console.error('인증 코드를 찾을 수 없습니다.');
        navigate('/login?error=kakao_auth_code_missing');
        return;
      }
      
      try {
        // 인증 코드로 토큰 요청
        const tokenResponse = await window.Kakao.Auth.authorize({
          redirectUri: `${window.location.origin}/auth/kakao/callback`,
          code
        });
        
        const { access_token } = tokenResponse;
        
        // 사용자 정보 요청
        const userResponse = await window.Kakao.API.request({
          url: '/v2/user/me'
        });
        
        const kakaoAccount = userResponse.kakao_account;
        
        if (!kakaoAccount || !kakaoAccount.email) {
          console.error('카카오 계정에서 이메일 정보를 가져올 수 없습니다.');
          navigate('/login?error=kakao_info_missing');
          return;
        }
        
        // 이름 정보 가져오기
        let name = '';
        if (kakaoAccount.profile && kakaoAccount.profile.nickname) {
          name = kakaoAccount.profile.nickname;
        }
        
        // 이름 분리 (성과 이름)
        let firstName = '';
        let lastName = '';
        
        if (name) {
          const nameParts = name.split(' ');
          if (nameParts.length > 1) {
            lastName = nameParts[0];
            firstName = nameParts.slice(1).join(' ');
          } else {
            firstName = name;
            lastName = '';
          }
        }
        
        // 부모 창으로 데이터 전달 (팝업인 경우)
        if (window.opener) {
          window.opener.postMessage({
            type: 'kakao_login',
            data: {
              token: access_token,
              email: kakaoAccount.email,
              firstName,
              lastName,
              kakaoId: userResponse.id
            }
          }, window.location.origin);
          window.close();
        } else {
          // 직접 로그인 처리
          try {
            const success = await kakaoLogin(access_token, {
              email: kakaoAccount.email,
              firstName,
              lastName,
              kakaoId: userResponse.id
            });
            
            if (success) {
              navigate('/dashboard');
            } else {
              navigate('/login?error=kakao_login_failed');
            }
          } catch (error) {
            console.error('카카오 로그인 처리 중 오류:', error);
            navigate('/login?error=kakao_login_error');
          }
        }
      } catch (error) {
        console.error('카카오 로그인 처리 중 오류:', error);
        navigate('/login?error=kakao_auth_error');
      }
    };
    
    processKakaoLogin();
  }, [navigate, location, kakaoLogin]);
  
  return (
    <div className="social-callback-container">
      <div className="loading-spinner"></div>
      <p>카카오 로그인 처리 중입니다. 잠시만 기다려주세요...</p>
    </div>
  );
};

export default KakaoCallback; 